import apiClient from './apiClient';

export interface RedisCacheCheck {
  productId: string;
  retailer: string;
  existsInRedis: boolean;
  productTitle?: string;
  price?: number;
  cachedAt?: string;
  ttlInfo?: string;
}

export interface RedisCacheStats {
  totalKeys: number;
  productKeys: number;
  shippingKeys: number;
  memoryUsed: string;
  memoryUsedHuman: string;
  totalConnections: number;
  redisVersion: string;
}

const redisCacheAdminService = {
  checkProduct: async (productId: string, retailer: string) => {
    const response = await apiClient.get(`/admin/redis-cache/product/${productId}/${retailer}`);
    return response.data;
  },

  getStats: async () => {
    const response = await apiClient.get('/admin/redis-cache/stats');
    return response.data;
  },

  flushProduct: async (productId: string, retailer: string) => {
    const response = await apiClient.delete(`/admin/redis-cache/product/${productId}/${retailer}`);
    return response.data;
  },

  flushAllProducts: async () => {
    const response = await apiClient.delete('/admin/redis-cache/flush-all-products');
    return response.data;
  },
};

export default redisCacheAdminService;

